<template>
    <div class="com-sgp-right text-white">
        <div>
            <BlockBox title="指标体系雷达图" enTitle="Indicator Radar" height="296" titleType="right">
                <template #titleLabel>
<!--                    <div class="radarTabs">-->
<!--                        <span class="tabItem" :class="{active: radarLevel === 'school'}" @click="switchRadarLevel('school')">校级</span>-->
<!--                        <span class="tabItem" :class="{active: radarLevel === 'grade'}" @click="switchRadarLevel('grade')">年级</span>-->
<!--                    </div>-->
                </template>
                <template #content>
                    <div class="radarContentWrap">
<!--                        <div class="radarFilter">-->
<!--                            <el-select v-model="radarIndicatorType" size="mini" style="width:160px;" popper-append-to-body>-->
<!--                                <el-option label="五育童真好少年" value="wuyu"></el-option>-->
<!--                                <el-option label="六个一指标体系" value="six"></el-option>-->
<!--                            </el-select>-->
<!--                        </div>-->
                        <div id="chartRadar" style="height:200px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        <div class="margin-top-15">
            <BlockBox title="指标得分总览" enTitle="Score Overview" height="326" titleType="right">
                <template #titleLabel>
<!--                    <div class="overviewTabs">-->
<!--                        <span class="tabItem" :class="{active: overviewLevel === 'grade'}" @click="switchOverviewLevel('grade')">年级</span>-->
<!--                        <span class="tabItem" :class="{active: overviewLevel === 'class'}" @click="switchOverviewLevel('class')">班级</span>-->
<!--                    </div>-->
                </template>
                <template #content>
<!--                    <div class="overviewFilter">-->
<!--                        <el-select v-model="overviewType" size="mini" style="width:160px;" popper-append-to-body>-->
<!--                            <el-option label="五育童真好少年" value="wuyu"></el-option>-->
<!--                            <el-option label="六个一指标体系" value="six"></el-option>-->
<!--                        </el-select>-->
<!--                    </div>-->
                    <div class="overviewTable">
                        <div class="tableHeader flex align-center">
                            <div class="col-name">年级名称</div>
                            <div class="col-count">学生总数</div>
                            <div class="col-score">平均积分</div>
                        </div>
                        <div class="tableBody">
                            <div class="tableRow flex align-center" v-for="(row, index) in gradeList" :key="index">
                                <div class="col-name">{{row.gradeName}}</div>
                                <div class="col-count">{{row.studentCount}}</div>
                                <div class="col-score">{{row.avgScore}}</div>
                            </div>
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        <div class="margin-top-15">
            <BlockBox title="指标之星" enTitle="Indicator Star" height="329">
                <template #content>
<!--                    <div class="rightFilter">-->
<!--                        <el-select v-model="starIndicator" size="mini" style="width:120px;" popper-append-to-body>-->
<!--                            <el-option label="六个一指标体系" value="six"></el-option>-->
<!--                        </el-select>-->
<!--                        <el-select v-model="starGrade" size="mini" style="width:120px;margin-left:5px;" popper-append-to-body>-->
<!--                            <el-option label="全部年级" value="all"></el-option>-->
<!--                        </el-select>-->
<!--                        <el-select v-model="starClass" size="mini" style="width:120px;margin-left:5px;" popper-append-to-body>-->
<!--                            <el-option label="全部班级" value="all"></el-option>-->
<!--                        </el-select>-->
<!--                    </div>-->
                    <div class="starContent">
                        <div class="starRank">
                            <div class="rankHeader">积分排行榜</div>
                            <div class="rankList">
                                <div class="rankItem flex align-center" v-for="(item, index) in rankList" :key="index">
                                    <span class="rankNo" :class="'no' + (index + 1)">{{index + 1}}</span>
                                    <span class="rankName">{{item.studentName}}   <span style="padding-left: 20px;">{{item.score||'0'}}积分</span> </span>
                                </div>
                            </div>
                        </div>
                        <div class="starRadar">
                            <div id="chartStarRadar" style="width:100%;height:180px;"></div>
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import echartMixins from "@/utils/resizeMixins";
    import BlockBox from '@/views/components/blockBox'
    import { rightDataSchool } from "@/api/api";
    
    export default {
        name: "sgpRightContent",
        components: {
            BlockBox
        },
        mixins: [echartMixins],
        data() {
            return {
                radarLevel: 'school',
                radarIndicatorType: 'wuyu',
                overviewLevel: 'grade',
                overviewType: 'grade',
                starIndicator: 'six',
                starGrade: 'all',
                starClass: 'all',
                indexList:[],
                radarData: {
                    wuyu: [
                        { name: '健体', value: 65 },
                        { name: '崇德', value: 45 },
                        { name: '启智', value: 55 },
                        { name: '尚美', value: 70 },
                        { name: '爱劳', value: 50 },
                    ],
                    six: [
                        { name: '创新作品', value: 65 },
                        { name: '研学旅行', value: 45 },
                        { name: '精彩演说', value: 55 },
                        { name: '美观汉字', value: 70 },
                        { name: '艺术特长', value: 50 },
                        { name: '运动习惯', value: 80 },
                    ]
                },
                gradeRadarData: {
                    wuyu: [
                        { name: '1年级', data: [70, 50, 60, 75, 55] },
                        { name: '2年级', data: [60, 40, 50, 65, 45] },
                        { name: '3年级', data: [65, 45, 55, 70, 50] },
                    ],
                    six: [
                        { name: '1年级', data: [70, 50, 60, 75, 55, 85] },
                        { name: '2年级', data: [60, 40, 50, 65, 45, 75] },
                        { name: '3年级', data: [65, 45, 55, 70, 50, 80] },
                    ]
                },
                gradeColors: ['#247bf1', '#67e591', '#ffc832'],
                gradeList: [],
                rankList: [
                    { name: '陈奕潼' },
                    { name: '胡琳林' },
                    { name: '陆芯一' },
                    { name: '吴佳颖' },
                    { name: '顾晨耀' },
                ],
                cityIndexList: [
                    { name: '创新作品', value: 80 },
                    { name: '研学旅行', value: 60 },
                    { name: '精彩演说', value: 70 },
                    { name: '美观汉字', value: 90 },
                    { name: '艺术特长', value: 65 },
                    { name: '运动习惯', value: 95 },
                ],
                timerRight: null,
            }
        },
        mounted() {

        },
        beforeDestroy() {
            clearTimeout(this.timerRight);
            if (this.chart1) this.chart1.dispose();
            if (this.chart2) this.chart2.dispose();
        },
        watch: {
            radarIndicatorType() {
                this.$nextTick(() => {
                    this.drawRadar();
                });
            },
            radarLevel() {
                this.$nextTick(() => {
                    this.drawRadar();
                });
            },
            overviewType() {
                this.$nextTick(() => {
                    this.drawRadar();
                });
            },
            starIndicator() {
                this.$nextTick(() => {
                    this.drawStarRadar();
                });
            },
            starGrade() {
                this.$nextTick(() => {
                    this.drawStarRadar();
                });
            },
            starClass() {
                this.$nextTick(() => {
                    this.drawStarRadar();
                });
            }
        },
        methods: {
            init(schoolId){
              this.schoolId=schoolId;
              this.changeData();
              this.timerLeft = setTimeout(() => {
                this.changeData();
              }, 60000);

            },
            switchRadarLevel(level) {
                this.radarLevel = level;
            },
            switchOverviewLevel(level) {
                this.overviewLevel = level;
            },
            async changeData() {
                try {
                    const res = await rightDataSchool(this.schoolId);
                    if (res && res.data) {
                        if(res.data.indexList){
                          this.radarData.wuyu=res.data.indexList;
                        }

                        if (res.data.gradeList) this.gradeList = res.data.gradeList;
                        if (res.data.rankList) this.rankList = res.data.rankList;
                        if (res.data.cityIndexList) this.cityIndexList = res.data.cityIndexList;
                    }
                } catch (e) {
                    console.log('使用默认数据');
                }
                this.$nextTick(() => {
                    this.drawRadar();
                    this.drawStarRadar();
                });
            },
            drawRadar() {
                console.log(echarts)
                const chartDom = document.getElementById("chartRadar");
                if (!chartDom) return;
                if (this.chart1) this.chart1.dispose();
                this.chart1 = this.$echarts.init(chartDom);
                let indicator = [];
                let seriesData = [];
                const data = this.radarData[this.radarIndicatorType] || this.radarData.wuyu;
                const indicatorNames = data.map(item => item.name);
                const indicatorValues = data.map(item => item.value);
                let max=100;
              data.forEach(obj=>{
                if(obj.value>max){
                  max=obj.value;
                }
              })
                indicator = indicatorNames.map((name) => ({
                  name: name,
                  max: max,
                  textStyle: {
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 'bold'
                  }
                }));
              seriesData = [{
                value: indicatorValues,
                areaStyle: { color: 'rgba(0, 200, 255, 0.3)' },
                lineStyle: { color: '#00c8ff', width: 1.5 },
                itemStyle: { color: '#00c8ff' },
                symbol: 'circle',
                symbolSize: 4
              }];
                let option = {
                    legend: this.radarLevel === 'grade' ? {
                        data: (this.gradeRadarData[this.radarIndicatorType] || this.gradeRadarData.wuyu).map(g => g.name),
                        right: 10,
                        top: 10,
                        orient: 'vertical',
                        textStyle: { color: '#fff', fontSize: 12 }
                    } : undefined,
                    radar: {
                        indicator: indicator,
                        shape: 'polygon',
                        splitNumber: 4,
                        radius: '70%',
                        center: ['50%', '50%'],
                        name: {
                            textStyle: {
                                color: '#fff',
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(100, 180, 255, 0.2)'
                            }
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                color: ['rgba(20, 60, 120, 0.1)', 'rgba(20, 60, 120, 0.2)']
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(100, 180, 255, 0.3)'
                            }
                        }
                    },
                    series: [{
                        type: 'radar',
                        data: seriesData
                    }]
                };
                this.chart1.setOption(option);
                window.addEventListener("resize", () => {
                    this.chart1.resize();
                });
            },
            drawStarRadar() {
                this.chart2 = this.$echarts.init(document.getElementById("chartStarRadar"));
                // const colors = ['#ff9944', '#7766ff', '#44aaff', '#88ff99', '#33eeff', '#ddff44'];
                let max=0;
                this.cityIndexList.forEach(obj=>{
                  if(obj.value>max){
                    max=obj.value;
                  }
                })
                let option = {
                    radar: {
                        indicator: this.cityIndexList.map(item => ({
                            name: item.name,
                            max: max
                        })),
                        shape: 'polygon',
                        splitNumber: 4,
                        radius: '70%',
                        center: ['50%', '50%'],
                        name: {
                            textStyle: {
                                color: '#fff',
                                fontSize: 10,
                                fontWeight: 'bold'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(100, 180, 255, 0.2)'
                            }
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                color: ['rgba(20, 60, 120, 0.1)', 'rgba(20, 60, 120, 0.2)']
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(100, 180, 255, 0.3)'
                            }
                        }
                    },
                    series: [{
                        type: 'radar',
                        data: [{
                            value: this.cityIndexList.map(item => item.value),
                            areaStyle: {
                                color: 'rgba(0, 200, 255, 0.3)'
                            },
                            lineStyle: {
                                color: '#00c8ff',
                                width: 1.5
                            },
                            itemStyle: {
                                color: '#00c8ff'
                            },
                            symbol: 'circle',
                            symbolSize: 3
                        }]
                    }]
                };
                this.chart2.setOption(option);
                window.addEventListener("resize", () => {
                    this.chart2.resize();
                });
            }
        }
    }
</script>

<style lang="scss">
    .com-sgp-right {
        min-height: 500px;
        padding: 14px 15px 15px 15px;
        box-sizing: border-box;

        .radarContentWrap {
            padding: 10px 15px;
            box-sizing: border-box;

            .radarFilter {
                margin-bottom: 10px;
            }
        }

        .overviewTable {
            padding: 10px 15px;
            box-sizing: border-box;

            .tableHeader {
                height: 32px;
                background: rgba(20, 60, 120, 0.5);
                border-radius: 4px;
                font-weight: bold;
                font-size: 12px;
                color: #8df2ff;
                padding: 0 5px;

                .col-name { flex: 2; }
                .col-count { flex: 1; text-align: center; }
                .col-score { flex: 1; text-align: right; }
            }

            .tableBody {
                max-height: 190px;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 3px;
                }

                &::-webkit-scrollbar-thumb {
                    background: rgba(45, 163, 255, 0.5);
                    border-radius: 3px;
                }

                .tableRow {
                    height: 30px;
                    font-size: 12px;
                    border-bottom: 1px solid rgba(45, 163, 255, 0.1);
                    padding: 0 5px;
                    color: rgba(255, 255, 255, 0.8);

                    .col-name { flex: 2; }
                    .col-count { flex: 1; text-align: center; }
                    .col-score { flex: 1; text-align: right; color: #67e591; }

                    &:hover {
                        background: rgba(20, 60, 120, 0.3);
                    }
                }
            }
        }

        .overviewFilter {
            display: flex;
            align-items: center;
            padding: 10px 15px 0;
            box-sizing: border-box;
        }

        .overviewTabs {
            display: flex;
            align-items: center;
            gap: 15px;
            padding-right: 10px;

            .tabItem {
                font-size: 16px;
                color: rgba(255, 255, 255, 0.5);
                cursor: pointer;
                padding: 4px 8px;
                transition: all 0.3s;

                &:hover {
                    color: rgba(255, 255, 255, 0.8);
                }

                &.active {
                    color: #fff;
                    font-weight: bold;
                }
            }
        }

        .starContent {
            display: flex;
            padding: 10px 15px;
            box-sizing: border-box;

            .starRank {
                flex: 1;

                .rankHeader {
                    font-size: 13px;
                    font-weight: bold;
                    color: #8df2ff;
                    margin-bottom: 10px;
                    text-align: center;
                }

                .rankList {
                    .rankItem {
                        height: 28px;
                        font-size: 12px;
                        border-bottom: 1px solid rgba(45, 163, 255, 0.1);
                        padding: 0 5px;

                        .rankNo {
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 11px;
                            margin-right: 8px;
                            background: rgba(45, 163, 255, 0.2);
                            color: rgba(255, 255, 255, 0.7);

                            &.no1 {
                                background: rgba(255, 200, 50, 0.4);
                                color: #ffc832;
                            }

                            &.no2 {
                                background: rgba(200, 200, 200, 0.3);
                                color: #c8c8c8;
                            }

                            &.no3 {
                                background: rgba(205, 127, 50, 0.3);
                                color: #cd7f32;
                            }
                        }

                        .rankName {
                            color: rgba(255, 255, 255, 0.8);
                        }

                        &:hover {
                            background: rgba(20, 60, 120, 0.3);
                        }
                    }
                }
            }

            .starRadar {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    .radarTabs {
        display: flex;
        align-items: center;
        gap: 15px;
        padding-right: 10px;

        .tabItem {
            font-size: 16px;
            color: rgba(255, 255, 255, 0.5);
            cursor: pointer;
            padding: 4px 8px;
            transition: all 0.3s;

            &:hover {
                color: rgba(255, 255, 255, 0.8);
            }

            &.active {
                color: #fff;
                font-weight: bold;
            }
        }
    }

    .rightFilter {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
        padding: 10px 15px 0;
        box-sizing: border-box;
        z-index: 10;
        position: relative;
    }
</style>
